import React from "react";
import { BlockMath } from "react-katex";
import TheoryExamplesRunner from "../../components/TheoryExamplesRunner";

export default function TriangleRadiiPreparationTheory() {
  const intro = (
    <div className="space-y-3">
      <p>
        W trójkącie prostokątnym przeciwprostokątna jest średnicą okręgu
        opisanego, dlatego promień tego okręgu jest równy jej połowie.
        Dla okręgu wpisanego korzystamy z długości obu przyprostokątnych
        i przeciwprostokątnej.
      </p>
      <BlockMath math={String.raw`R=\frac{c}{2},\qquad r=\frac{a+b-c}{2}`} />
      <p>
        W trójkącie równobocznym wysokość dzieli się w stosunku 2:1:
        od wierzchołka do środka okręgu opisanego są dwie trzecie wysokości,
        a od środka do boku — jedna trzecia.
      </p>
      <BlockMath math={String.raw`h=\frac{a\sqrt3}{2},\qquad R=\frac23h=\frac{a\sqrt3}{3},\qquad r=\frac13h=\frac{a\sqrt3}{6}`} />
    </div>
  );

  const examples = [
    {
      label: "Przykład 1",
      summary: "Okrąg opisany na trójkącie prostokątnym",
      description: "Przeciwprostokątna ma długość 10.",
      content: <BlockMath math={String.raw`R=\frac{c}{2}=\frac{10}{2}=5`} />,
    },
    {
      label: "Przykład 2",
      summary: "Okrąg wpisany w trójkąt prostokątny",
      description: "Przyprostokątne mają długości 6 i 8, a przeciwprostokątna 10.",
      content: <BlockMath math={String.raw`r=\frac{6+8-10}{2}=2`} />,
    },
    {
      label: "Przykład 3",
      summary: "Trójkąt równoboczny wpisany w okrąg",
      description: "Promień okręgu opisanego wynosi siedem pierwiastków z trzech.",
      content: <BlockMath math={String.raw`R=\frac{a\sqrt3}{3}\quad\Longrightarrow\quad a=R\sqrt3=7\sqrt3\cdot\sqrt3=21`} />,
    },
  ];

  return <TheoryExamplesRunner intro={intro} examples={examples} />;
}
